import React, { useState, useEffect } from 'react';
import './Motors.css';

const Motors = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Premium Vehicles",
      subtitle: "Experience Excellence",
      background: "/motors/pic1.jpg"
    },
    {
      title: "Agricultural Machinery",
      subtitle: "Powering Progress",
      background: "/motors/pic2.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic3.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic4.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic5.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic6.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic7.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic8.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic9.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic10.jpg"
    },
    {
      title: "Commercial Vehicles",
      subtitle: "Built for Business",
      background: "/motors/pic11.jpg"
    }
  ];

  const brands = [
    {
      id: 1,
      name: "MAZ TRUCKS",
      logo: "/bz2.png",
      image: "/motors/pic3.jpg",
      description: "Belarusian automotive manufacturer offering heavy-duty trucks and commercial vehicles known for their durability and reliability in challenging conditions.",
      features: [
        "Heavy-duty commercial vehicles",
        "Proven reliability in extreme conditions",
        "Comprehensive after-sales support",
        "Customizable configurations"
      ],
      specs: {
        "Payload Capacity": "Up to 40 tons",
        "Engine Power": "300-550 HP",
        "Applications": "Construction, Logistics, Mining"
      }
    },
    {
      id: 2,
      name: "KAMAZ TRUCKS",
      logo: "/bz2.png",
      image: "/motors/pic2.jpg",
      description: "Russian manufacturer of heavy-duty trucks, famous for winning the Dakar Rally multiple times and providing robust vehicles for various industrial applications.",
      features: [
        "Dakar Rally proven performance",
        "Military-grade durability",
        "Fuel-efficient engines",
        "Global spare parts network"
      ],
      specs: {
        "Payload Capacity": "Up to 35 tons",
        "Engine Power": "280-500 HP",
        "Applications": "Long-haul, Construction, Specialized"
      }
    },
    {
      id: 3,
      name: "URAL TRUCKS",
      logo: "/bz2.png",
      image: "/motors/pic5.jpg",
      description: "Russian off-road truck manufacturer specializing in 6x6 and 8x8 all-wheel drive vehicles for extreme terrain and military applications.",
      features: [
        "All-wheel drive capabilities",
        "Extreme terrain performance",
        "Military proven reliability",
        "Simple maintenance design"
      ],
      specs: {
        "Drive Configuration": "6x6, 8x8",
        "Engine Power": "240-360 HP",
        "Applications": "Off-road, Military, Exploration"
      }
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="motors-container">
      {/* Hero Section */}
      <section className="motors_hero-section">
        <div className="motors_slideshow-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`motors_slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${slide.background})`
              }}
            >
              <div className="motors_slide-overlay">
                <div className="motors_slide-content">
                  <h1 className="car-title">{slide.title}</h1>
                  <p className="car-subtitle">{slide.subtitle}</p>
                  <button className="cta-button">Explore Now</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Navigation Arrows */}
        <button className="nav-arrow prev-arrow" onClick={prevSlide}>
          ‹
        </button>
        <button className="nav-arrow next-arrow" onClick={nextSlide}>
          ›
        </button>
        
        {/* Slide Indicators */}
        <div className="slide-indicators">
          {/* {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))} */}
        </div>
      </section>

      {/* Brands Showcase Section */}
      <section className="brands-showcase">
        <div className="brands-container">
          <div className="brands-header">
            <h2 className="brands-title">Our Brands</h2>
            <p className="brands-subtitle">
              Partnering with world-renowned manufacturers to bring you the best in automotive excellence
            </p>
          </div>

          <div className="brands-grid">
            {brands.map((brand) => (
              <div 
                key={brand.id} 
                className="brand-card"
                style={{ background: brand.background }}
              >
                <div className="brand-glass-effect">
                  <div className="brand-header">
                    <div className="brand-logo-container">
                      <img 
                        src={brand.logo} 
                        alt={`${brand.name} logo`}
                        className="brand-logo"
                      />
                    </div>
                    <h3 className="brand-name">{brand.name}</h3>
                  </div>

                  <div className="brand-content">
                    <div className="brand-image-container">
                      <img 
                        src={brand.image} 
                        alt={brand.name}
                        className="brand-image"
                      />
                      <div className="image-overlay"></div>
                    </div>

                    <div className="brand-info">
                      <p className="brand-description">{brand.description}</p>
                      
                      <div className="specs-grid">
                        {Object.entries(brand.specs).map(([key, value]) => (
                          <div key={key} className="spec-item">
                            <span className="spec-key">{key}</span>
                            <span className="spec-value">{value}</span>
                          </div>
                        ))}
                      </div>

                      <div className="features-list">
                        <h4 className="features-title">Key Features:</h4>
                        <ul className="features-items">
                          {brand.features.map((feature, index) => (
                            <li key={index} className="feature-item">
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>

                     
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="motors_content-section" id='cta-button'>
        <div className="motors_content-container">
          <h2 className="company-title">BAZRA MOTORS</h2>
          <div className="text-content">
            <p>
              BAZRA MOTORS is a motor engineering company who both assembles and represents 
              the big names in the automotive and agricultural machineries sector.
            </p>
            <p>
              BAZRA MOTORS is one of Automotive Distributors and Manufacturers in Ethiopia, 
              covering passenger cars and medium duty commercial vehicles. As part of its 
              diversification strategy, BAZRA MOTORS preparing to assemble Russian made 
              vehicles in Ethiopia.
            </p>
            <p>
              BAZRA MOTORS' extensive experience in the trade has given it the opportunity 
              to understand its customers and win their genuine confidence. Management and 
              employees are fully committed to serve their customers and maintain a fair 
              share of the market for the products the company distributes. More than that; 
              BAZRA MOTORS has finished to establish cars assembly facility in Kombolcha, 
              300 kms away from Addis Ababa agreed to assemble vehicles.
            </p>
            <p>
              BAZRA Motors provides vehicles, aftersales services as well as spare parts 
              for the vehicles it assembles and represents.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Motors;